import { forwardRef } from "react";

import {
  TABLE_CAPTION_CLASS_NAME,
  TABLE_CLASS_NAME,
  TABLE_DEFAULTS,
  type TTableProps,
} from "@/ui/components/data-display/Table/Table.config";
import { cn } from "@/ui/lib/utils";

export const Table = forwardRef<HTMLTableElement, TTableProps>(
  (
    {
      caption,
      captionHidden = TABLE_DEFAULTS.captionHidden,
      className,
      children,
      ...props
    },
    ref,
  ) => (
    <table
      {...props}
      ref={ref}
      data-component="Table"
      className={cn(TABLE_CLASS_NAME, className)}
    >
      <caption
        data-component="TableCaption"
        className={cn(TABLE_CAPTION_CLASS_NAME, captionHidden && "sr-only")}
      >
        { caption }
      </caption>
      { children }
    </table>
  ),
);

Table.displayName = "Table";
